import React, { Component } from "react";
import UniqueKey from "../common/UniqueKey";
import { UncontrolledTooltip,Badge } from "reactstrap";

class MultiSelectCustom extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      handsonData: [],
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      ttid2: "TTID" + String(Math.round(Math.random() * 1000000000))
    };
  }

  generateID() {
    return this.state.ttid;
  }

  generateID2() {
    return this.state.ttid2;
  }

  handleChange(e) {
    let x = this.props.parentState.errorMessages;
    x[this.props.component.name] = "";
    this.props.liftGlobalState({ name: "errorMessages" }, x);
    let vals = [...e.target.options].filter(o => o.selected).map(o => o.value);
    this.props.liftState(this.props.component, vals);
  }
  componentDidMount() {
    let { fileFolder, formState, modalname, pageData } = this.props.parentState;
    let { name, displayData, defaultValue } = this.props.component;
    if (
      pageData &&
      ((!modalname && !pageData[name]) || (modalname && ( !pageData[modalname] || !pageData[modalname][name]) )) &&
      defaultValue
    ) {
      this.props.liftState(this.props.component, defaultValue);
    }
  }
  render() {
    const { description,isReadOnly } = this.props.component;
    let { currentPage, fileFolder, formState } = this.props.parentState;
    let isReadOnly1 = false;
    if (( formState != 'edit' && fileFolder.isOpen) || isReadOnly == true || (formState == 'edit' && isReadOnly == 'edit' && fileFolder.isOpen)) {
      isReadOnly1 = true;
    }
    const tooltipID = this.generateID();
    const tooltipID2 = this.generateID2();
    return (
      <div
        key={this.props.index}
        className={`form-group   ${this.props.component.widths.parent}`}
      >
        <label
          id={tooltipID}
          className="col-form-label col-form-label-sm nopadding"
        >
          {this.props.label}
        </label>
        
        {/* {" " + this.props.parentState.errorMessages != undefined ? (
          <span>
            <Badge
              style={{ cursor: "pointer", marginLeft: "5px", fontSize: "8px" }}
              id={tooltipID2}
              color="danger"
            >
              {this.props.parentState.errorMessages[name]}
            </Badge>
            <UncontrolledTooltip placement="right" target={tooltipID2}>
              please select{" "}
            </UncontrolledTooltip>
          </span>
        ) : (
          ""
        )} */}
        <div className="input-group input-group-sm">
          {this.props.component.prepend && (
            <div className="input-group-prepend">
              <div className="input-group-text">
                {this.props.component.prepend}
              </div>
            </div>
          )}

          <select
            className="col-12 form-control form-control-sm"
            multiple
            readOnly={isReadOnly1}
            name={this.props.name}
            value={this.props.value}
            onChange={this.handleChange}
          >
            <option value="0">Select {this.props.name}</option>
            {this.props.component.options.map((val, index) => (
              <option key={val + index + "-" + UniqueKey()} value={val}>
                {val}
              </option>
            ))}
          </select>

          {this.props.component.append && (
            <div className="input-group-append">
              <div className="input-group-text">
                {this.props.component.append}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default MultiSelectCustom;
